export default "__VITE_PUBLIC_ASSET__fedee049__"